<template>
  <span>
    {{ $t("tiles.calibratingRate") }}
    <wx-contextualized-help :help-card-title="$t('tiles.calibratingRate')" :max-width="320" is-help-card>
      <template v-slot:help-card-text-slot>
        <p>
          {{ $t("tiles.calibratingRateTooltip.text") }}
        </p>
        <p class="mb-0">
          <a
            :href="$t('tiles.calibratingRateTooltip.academyLink.href')"
            :title="$t('tiles.calibratingRateTooltip.academyLink.hint')"
            target="productionRun"
          >
            {{ $t("tiles.calibratingRateTooltip.academyLink.text") }}
          </a>
        </p>
      </template>
    </wx-contextualized-help>
  </span>
</template>

<script>
import WxContextualizedHelp from "@/components/ui/WxContextualizedHelp.vue";

export default {
  name: "ProductRateCalibration",
  components: { WxContextualizedHelp },
};
</script>
